import React from 'react';

// 根据实际 shaixuan.svg 内容填充 path（示例为占位符，需替换为真实 SVG 路径）
const FilterIcon = ({name, color}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={name} width="20" height="20" viewBox="0 0 1024 1024">
    <path d="M956.16 96.32c7.232 17.408 4.224 32.256-8.896 44.544L633.984 454.592v472.192a38.144 38.144 0 0 1-24.768 37.568 44.416 44.416 0 0 1-15.872 3.2 37.76 37.76 0 0 1-28.608-12.096l-162.688-162.944a39.04 39.04 0 0 1-12.032-28.608V454.592L76.736 140.864c-13.12-12.288-16.128-27.136-8.896-44.544 7.232-16.512 19.712-24.832 37.504-24.832h813.376c17.728 0.064 30.208 8.32 37.44 24.832z" fill={color} />
  </svg>
);

export default FilterIcon;
